import "./style.css";
import ReactDataTable from "../../Components/ReactDataTable";
import moment from "moment";
import ActionButton from "../../Components/ReactDataTable/ActionButton";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import ResponsiveDialog from "../../Components/DialogBox";
import {
  getAllUsersDataAction,
  getInvitedUsersDataAction,
  getPractionersDataAction,
  getUsersDataAction,
  userRemoveAction,
  updateUserStatusAction,
  patientRemoveAction,
} from "../../Redux/Actions/userAction";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useMemo } from "react";
import { Box, List, Stack, Button, ButtonGroup } from "@mui/material";
import InvitePatientModal from "./InvitePatientModal";
import HelmetReact from "../../Components/Helmet";
import { useErrorHandler } from "../../hooks";
import { useLocation } from "react-router-dom";
import FilterComponent from "../../Components/ReactDataTable/FilterComponent";
import ReactLoading from "react-loading";

export const Users = () => {
  const dispatch = useDispatch();

  //reducer data
  const {
    userList,
    practionerList,
    allUserList,
    invitedUserList,
    loading,
    totalCount,
  } = useSelector((state) => state.User);
  const userData = JSON.parse(localStorage.getItem("userData"));

  const { setMsgConfig } = useErrorHandler();
  const location = useLocation();

  //states
  const [tabNavigate, setTabNavigate] = useState(null);
  const [selectedTab, setSelectedTab] = useState("CLIENTS");
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [open, setOpen] = useState(false);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [navigateUrl, setNavigateUrl] = useState("/users/overview/");
  const [itemId, setItemId] = useState();
  const [loaderTimeOut, setLoaderTimeOut] = useState(false);
  let data;

  //set data to display
  if (selectedTab === "CLIENTS" && userData?.role === "doctor") {
    data = userList?.patients?.map((e) => e);
  } else if (selectedTab === "PRACTIONERS") {
    data = practionerList ? practionerList?.map((e) => e) : "";
  } else if (selectedTab === "CLIENTS" && (userData?.role === "admin" || userData?.role === "researcher")) {
    data = allUserList ? allUserList?.map((e) => e) : "";
  } else if (selectedTab === "INVITED") {
    data = invitedUserList?.patients?.map((e) => e);
  }
  //handle back rotues
  useEffect(() => {
    location?.state
      ? setTabNavigate(location?.state)
      : setTabNavigate("CLIENTS");
  }, [location?.state, tabNavigate]);
  useEffect(() => {
    if (tabNavigate) {
      setSelectedTab(tabNavigate);
    }
  }, [tabNavigate]);

  useEffect(() => {
    if (selectedTab === "CLIENTS" && userData?.role === "doctor") {
      setNavigateUrl(`/users/overview/`);
    } else if (selectedTab === "INVITED" && userData?.role === "doctor") {
      setNavigateUrl(`/users/overview/`);
    } else if (selectedTab === "PRACTIONERS" && userData?.role === "admin") {
      setNavigateUrl(`/users/practioners/`);
    } else if (selectedTab === "CLIENTS" && (userData?.role === "admin" || userData?.role === "researcher")) {
      setNavigateUrl(`/users/clients/`);
    }
  }, [selectedTab]);

  const onTableChange = (filter) => {
    if (selectedTab === "CLIENTS" && userData?.role === "doctor") {
      const searchPayload = {
        key: filterText || "",
        perPage: filter?.perpage || 10,
        page: filter?.page || 1,
        sortBy: filter?.sortBy || "id",
        sortDirection: filter?.direction || "ASC",
      };
      dispatch(getUsersDataAction(searchPayload));
    } else if (selectedTab === "PRACTIONERS") {
      const searchPayload = {
        key: filterText || "",
        perPage: filter?.perpage || 10,
        page: filter?.page || 1,
        sortBy: filter?.sortBy || "id",
        sortDirection: filter?.direction || "ASC",
      };

      dispatch(getPractionersDataAction(searchPayload));
    } else if (selectedTab === "CLIENTS" && (userData?.role === "admin" || userData?.role === "researcher")) {
      const searchPayload = {
        key: filterText || "",
        perPage: filter?.perpage || 10,
        page: filter?.page || 1,
        sortBy: filter?.sortBy || "id",
        sortDirection: filter?.direction || "ASC",
      };
      dispatch(getAllUsersDataAction(searchPayload));
    } else if (selectedTab === "INVITED") {
      const searchPayload = {
        key: filterText || "",
        perPage: filter?.perpage || 10,
        page: filter?.page || 1,
        sortBy: filter?.sortBy || "id",
        sortDirection: filter?.direction || "ASC",
      };
      dispatch(getInvitedUsersDataAction(searchPayload));
    }
  };

  useEffect(() => {
    onTableChange();
  }, [selectedTab, filterText]);

  //filter
  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e)}
        onClear={handleClear}
        filterText={filterText}
        placeHolder="Search by name"
      />
    );
  }, [filterText, resetPaginationToggle]);

  //handle status changed
  const handleStatusChange = (item, value) => {
    if (value === "Delete") {
      setIsVisibleModal(true);
      setItemId(item?.id);
    } else {
      const payload = {
        Id: item?.id,
        is_active: value,
        user_type: selectedTab,
      };
      dispatch(updateUserStatusAction(payload));
      setMsgConfig({
        alertOpen: true,
        message: "User Status Update SuccessFully!!",
        severity: "success",
        autoHideDuration: 10000,
      });
    }
  };
  //handle Confirm
  const handleConfirm = () => {
    const payload = {
      Id: itemId,
      user_type: selectedTab,
    };
    if (userData?.role === "doctor") {
      dispatch(patientRemoveAction(payload));
    } else {
      dispatch(userRemoveAction(payload));
    }
    setIsVisibleModal(false);
    setMsgConfig({
      alertOpen: true,
      message: "Remove User SuccessFully!!",
      severity: "success",
      autoHideDuration: 1000,
    });
  };
  //remove user
  const RemoveItem = (item) => {
    setIsVisibleModal(true);
    setItemId(item?.id);
  };
  //columns
  const columns = [
    {
      name: "Name",
      sortField: "name",
      omit: userData?.role === "researcher" ? true : false,
      sortable: true,
      selector: (row) =>
        userData?.role === "doctor" ? row.patient.first_name : row.first_name,

      cell: (row) => {
        return (
          <span className="badge bg-light-danger">
            <span>
              {userData?.role === "doctor"
                ? row?.patient.first_name + " " + row?.patient.last_name
                : row?.first_name + " " + row?.last_name}
            </span>
          </span>
        );
      },
    },
    {
      name: "ID",
      sortField: "id",
      omit: userData?.role === "admin" || userData?.role === "doctor"  ? true : false,
      sortable: true,
      selector: (row) =>
       row.id,
      cell: (row) => {
        return (
          <span className="badge bg-light-danger">
            <span>
              {row.id}
            </span>
          </span>
        );
      },
    },
    {
      name: "Email",
      sortField: "email",
      omit: userData?.role === "researcher" ? true : false,
      sortable: true,
      selector: (row) =>
        userData?.role === "doctor" ? row.patient.email : row.email,

      cell: (row) => {
        return (
          <span className="badge bg-light-danger">
            <span>
              {userData?.role === "doctor" ? row.patient.email : row.email}
            </span>
          </span>
        );
      },
    },
    {
      name: "Last login",
      sortField: "last_login",
      sortable: true,
      selector: (row) =>
        userData?.role === "doctor" ? row.patient.last_login : row.last_login,

      cell: (row) => {
        return (
          <span className="badge bg-light-danger">
            <span>
              {userData?.role === "doctor"
                ? row.patient.last_login
                  ? moment(row.patient.last_login).format("DD/MM/YYYY")
                  : "NA"
                : row.last_login
                ? moment(row.last_login).format("DD/MM/YYYY")
                : "NA"}
            </span>
          </span>
        );
      },
    },
    {
      name: "Account status",
      center: true,
      sortField: "is_active",
      sortable: true,
      selector: (row) => row.is_active,
      omit: userData?.role === "admin" ? false : true,
      cell: (row) => {
        return (
          <>
            <Box sx={{ display: "flex", gap: "10px" }}>
              <span className="badge bg-light-danger">
                <span className="status">
                  {row.is_active ? "Active" : "Inactive"}
                </span>
              </span>
              <span className="status-icon-btn view-detail-btn">
                <ActionButton
                  isUpdateIcon={true}
                  handleStatusChange={handleStatusChange}
                  item={row}
                />
              </span>
            </Box>
          </>
        );
      },
    },
    {
      name: "ACTION",
      right: true,
      omit: userData?.role === "researcher" ? true : false,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      cell: (row) => {
        return (
          <>
            <span className="remove-icon-btn view-detail-btn">
              <ActionButton
                isRemoveIcon={true}
                RemoveItem={RemoveItem}
                item={row}
              />
            </span>
          </>
        );
      },
    },
    {
      name: "",
      right: true,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      cell: (row) => {
        const url = (id) => {
          if (selectedTab !== "PRACTIONERS") {
            return `/users/overview/${id}`;
          } else {
            return `/users/practioners/${id}`;
          }
        };
        const newURl = url(row.id);
        const getTab = () => {
          if (selectedTab === "INVITED") {
            return "INVITED";
          } else {
            return "";
          }
        };
        return (
          <span className="badge bg-light-danger view-detail-btn">
            <ActionButton
              isViewIcon={true}
              goToDetailScreen={newURl}
              item={row}
              tab={getTab()}
            />
          </span>
        );
      },
    },
  ];
  return (
    <>
      <ResponsiveDialog
        dtype="confirm"
        open={isVisibleModal}
        header="Are you sure you want to delete this user?"
        onConfirm={() => handleConfirm()}
        onClose={() => setIsVisibleModal(false)}
      ></ResponsiveDialog>
      <HelmetReact name="User" />
      <Box className="d-details-box">
        <ButtonGroup variant="text" aria-label="text button group">
          <Button
            className={`${selectedTab === "CLIENTS" ? "active" : ""}`}
            onClick={() => {
              setLoaderTimeOut(true);
              setTimeout(() => {
                setLoaderTimeOut(false);
              }, 1000);
              setSelectedTab("CLIENTS");
              setFilterText("");
            }}
          >
            CLIENTS
          </Button>
          {userData?.role === "admin" ? (
            <Button
              className={`${selectedTab === "PRACTIONERS" ? "active" : ""}`}
              onClick={() => {
                setLoaderTimeOut(true);
                setTimeout(() => {
                  setLoaderTimeOut(false);
                }, 1000);
                setSelectedTab("PRACTIONERS");
                setFilterText("");
              }}
            >
              PRACTIONERS
            </Button>
          ) : userData?.role === "doctor" ? (
            <Button
              className={`${selectedTab === "INVITED" ? "active" : ""}`}
              onClick={() => {
                setLoaderTimeOut(true);
                setTimeout(() => {
                  setLoaderTimeOut(false);
                }, 1000);
                setSelectedTab("INVITED");
                setFilterText("");
              }}
            >
              INVITED
            </Button>
          ) : ''}
        </ButtonGroup>
        <List component={Stack} direction="row"></List>

        {userData?.role === "doctor" ? (
          <Box
            sx={{
              textAlign: "right",
            }}
          >
            <Button
              variant="contained"
              onClick={(e) => {
                e.stopPropagation();
                setOpen(!open);
              }}
              className="invite-btn"
            >
              INVITE CLIENT
            </Button>
          </Box>
        ) : null}
        {loaderTimeOut ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: 15,
            }}
          >
            <ReactLoading
              type="cylon"
              height="80px"
              width="80px"
              color="#39a2e8"
            />
          </Box>
        ) : (
          <ReactDataTable
            columns={columns}
            items={data}
            onChange={onTableChange}
            totalRows={totalCount}
            isLoading={loading}
            navigateUrl={navigateUrl}
            isShowSearch={true}
            paginationResetDefaultPage={resetPaginationToggle}
            subHeader
            subHeaderComponent={subHeaderComponentMemo}
            persistTableHead
          />
        )}
      </Box>
      {open && <InvitePatientModal open={open} setOpen={setOpen} />}
    </>
  );
};
